module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADTSURBVHgBtZLBDcIwDEVNQeIGC7QDIFiAIycYALoIE7AAYoFOAANATxzpHYkBoAuUBfhWHSm0LrgSfOkpyk/sOHGI/qQ5SEEOTmDVNvgCpiAEMcjENylVNnOyAxmVt/EDxSvAoOJF4tfUVbw+mIGz563BncoHfVNHScCnu/te5fQhWEoVPE/AEWwDpdRExocc8JR55K2zFqQEc7s2VH8Dt86VcUe4U+Pqhkzu2qT9p+CYvvf51hTsspt/mr+3J+OEykcLDcHckR0Y+QlIyrOqoF/pBXakJYjSMSrzAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/englishVoice/icon_check_user.png
// module id = N4rG
// module chunks = 4